<template>
  <div class="settings-modules">
    <div v-if="!loadingData">
      <table-layout
        pkField="module_id"
        :selected.sync="selected"
        :isAdmin="isAdmin"
        :loading="loadingData"
        :items="customModules"
        :columns="columns"
        :addNewUpload="'zip_module'"
        :addOptions="['uploaded']"
        @click:addNew="uploaded"
        @uploaded="uploaded"
      >
        <template #actions>
          <b-dropdown-item @click="openDialogUpgrade" aria-role="listitem">{{$t('settings.module.upgrade')}}</b-dropdown-item>
          <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{$t('server.actions.delete')}}</b-dropdown-item>
        </template>
      </table-layout>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import TableLayout from '@/layout/TableLayout'
import Loader from '@/components/Loader'

export default {
  components: {
    TableLayout,
    Loader
  },
  props: ['modules', 'loading', 'isAdmin'],
  data() {
    return {
      loadingData: false,
      customModules: [],
      selected: {},
      columns: [
        {
          sortable: true,
          field: 'module_name',
          label: 'settings.module.name'
        },
        {
          sortable: true,
          field: 'type',
          label: 'settings.module.type'
        },
        {
          sortable: false,
          field: 'version',
          label: 'settings.module.version'
        },
        {
          sortable: true,
          field: 'latest_version',
          label: 'settings.module.latest_version'
        },
        {
          sortable: false,
          field: 'description',
          label: 'settings.module.description',
          bindHtml: true
        }
      ]
    }
  },
  methods: {
    uploaded(data) {
      this.$emit('refetch', data)
    },
    setCustomModules(newCustomModules) {
      if (newCustomModules) {
        this.customModules = this.$lodash.cloneDeep(newCustomModules)
      }
    },
    upgradeModules(module_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/modules/upgrade`
      this.loadingData = true
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          module_ids: module_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
    },
    openDialogUpgrade() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const custom_modules = this.customModules
        .filter(value => {
          return indexSet.has(value.module_id)
        })
        .map(d => {
          return d['module_name']
        })
      const msg = custom_modules
        .map(d => {
          return d
        })
        .join(', ')
      this.$dialog.confirm({
        message: `${this.$t('confirm.upgrade', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.upgradeModules(this.selected)
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.loadingData = false
            })
        }
      })
    },
    removeModules(module_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/modules/delete`
      this.loadingData = true
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          module_ids: module_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          const indexSet = new Set(module_ids)
          this.customModules = this.customModules.filter(value => {
            return !indexSet.has(value.module_id)
          })
          this.selected = []
        })
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const custom_modules = this.customModules
        .filter(value => {
          return indexSet.has(value.module_id)
        })
        .map(d => {
          return d['module_name']
        })
      const msg = custom_modules
        .map(d => {
          return d
        })
        .join(', ')
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.removeModules(this.selected)
            .then(() => {
              this.notifyModule({
                name: msg,
                status: 'deleted'
              })
            })
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.loadingData = false
            })
        }
      })
    },
    notifyModule(variables) {
      this.$notify({
        message: `${this.$t('notification.moduleWas', {
          module: variables.name,
          status: this.$t(`notification.user.${variables.status}`)
        })}.`,
        type: 'success'
      })
    }
  },
  watch: {
    modules: {
      immediate: true,
      deep: true,
      handler: 'setCustomModules'
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-modules {
}
</style>
